export default __webpack_public_path__ + "static/media/QC.71d72324.svg";